import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { motion } from "framer-motion";
import { useLang, copy } from "@/i18n";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AccessoPage() {
  const { lang } = useLang();
  const c = copy[lang].private;
  const [state, setState] = useState("checking");

  useEffect(() => {
    const token = sessionStorage.getItem("fmf_access");
    if (!token) {
      setState("denied");
      return;
    }
    axios
      .get(`${API}/access/session`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(() => setState("granted"))
      .catch(() => {
        sessionStorage.removeItem("fmf_access");
        setState("denied");
      });
  }, []);

  return (
    <div
      data-testid="private-area"
      className="min-h-screen flex flex-col items-center justify-center px-6 text-center"
      style={{ background: "rgba(6, 6, 5, 0.5)", color: "var(--bone)" }}
    >
      <img
        data-testid="private-logo"
        src="/fmf-logo.png"
        alt="FMF"
        className="w-28 mix-blend-screen"
      />
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 2.4, delay: 0.6 }}
        className="mt-16"
      >
        {state === "checking" && (
          <p data-testid="private-checking" className="text-sm text-[var(--bone-dim)]">
            {c.checking}
          </p>
        )}
        {state === "granted" && (
          <>
            <h1
              data-testid="private-granted-heading"
              className="font-serif-fmf font-light text-3xl md:text-5xl leading-tight"
            >
              {c.granted}
            </h1>
            <p
              data-testid="private-granted-note"
              className="mt-10 max-w-md mx-auto text-sm leading-relaxed text-[var(--bone-dim)]"
            >
              {c.preparing}
            </p>
          </>
        )}
        {state === "denied" && (
          <h1
            data-testid="private-denied-heading"
            className="font-serif-fmf font-light text-3xl md:text-5xl leading-tight"
          >
            {c.invalid}
          </h1>
        )}
      </motion.div>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 2, delay: 2.2 }}
        className="mt-20"
      >
        <Link
          data-testid="private-back-link"
          to="/"
          className="font-mono-fmf text-[15px] tracking-[0.4em] uppercase text-[var(--bone-dim)] hover:text-[var(--bone)] transition-colors duration-700"
        >
          {c.back}
        </Link>
      </motion.div>
    </div>
  );
}
